import { __decorate, __metadata } from "tslib";
import { IsEmail, IsString, MinLength } from 'class-validator';
import { IS_EMAIL_DEFAULT_OPTIONS } from '../../shared/validator';
// The minimum was originally 6, then later changed to 8.
// As a result, we need to keep 6 as the minimum for validating on login.
export const LEGACY_PASSWORD_MIN_LENGTH = 6;
// Use when asking a user to create a new password, either by signup, reset, or change password
export const NEW_PASSWORD_MIN_LENGTH = 12;
/**
 * A request to set a password for a user by their email address.
 */
export class SetUserPasswordRequest {
    /**
     *
     * @param email The email address of the user whose password will be set.
     * @param password The new password to set for the user
     */
    constructor(email, password) {
        this.email = email;
        this.password = password;
    }
}
__decorate([
    IsEmail(IS_EMAIL_DEFAULT_OPTIONS),
    __metadata("design:type", String)
], SetUserPasswordRequest.prototype, "email", void 0);
__decorate([
    IsString(),
    MinLength(NEW_PASSWORD_MIN_LENGTH),
    __metadata("design:type", String)
], SetUserPasswordRequest.prototype, "password", void 0);
